'use strict';

class collapse {
  constructor(elem) {
    this.elem = elem;
    this.otherCollapse = document.querySelectorAll('.js-collapse:not([data-collapse-manualy])');
    this.collapseButton = (this.elem.dataset.collapseTrigger) ? this.elem.querySelector(this.elem.dataset.collapseTrigger) : this.elem.querySelector('.js-collapse-btn');
    this.autoCollapse = typeof this.elem.dataset.collapseManualy !== 'undefined' ? false : true;
    this.target = this.elem.querySelector(this.collapseButton.dataset.collapseTarget);

    this.events();
  }

  toggleCollapse() {

    // hide all collapse
    for (let otherCollapse of this.otherCollapse) {
      if(otherCollapse !== this.elem && otherCollapse.classList.contains('collapsed')) {
         otherCollapse.collapse.close()
      }
    }

    this.target.classList.toggle('active');
    this.elem.classList.toggle('collapsed');

    let expanded = this.target.getAttribute('aria-expanded');
    this.target.setAttribute('aria-expanded', expanded == "true" ? "false" : "true");

    if (this.collapseButton.dataset.collapseToggledLabel) {
      const currentLabel = this.collapseButton.textContent;
      this.collapseButton.textContent = this.collapseButton.dataset.collapseToggledLabel;
      this.collapseButton.dataset.collapseToggledLabel = currentLabel;
    }
  }

  close() {
    this.target.setAttribute('aria-expanded', "false");
    this.target.classList.remove('active');
    this.elem.classList.remove('collapsed');

    if (this.collapseButton.dataset.collapseToggledLabel) {
      const currentLabel = this.collapseButton.textContent;
      this.collapseButton.textContent = this.collapseButton.dataset.collapseToggledLabel
      this.collapseButton.dataset.collapseToggledLabel = currentLabel;
    }
  }

  events() {
    if (this.autoCollapse) {
      document.querySelector('html').addEventListener('click', e => {
        if (this.target.classList.contains('active')) {
          this.close();
        }
      });
    }

    this.target.addEventListener('click', e => {
      e.stopPropagation();
    });

    this.collapseButton.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      
      this.toggleCollapse();
    });
  }
}

const initCollapses = (wrapper) => {
  const collapsesWrapper = wrapper ? wrapper : document;
  const collapseElems = collapsesWrapper.querySelectorAll('.js-collapse');
  for (let collapseElem of collapseElems) {
    if (typeof collapseElem.collapse === 'undefined') {
      collapseElem.collapse = new collapse(collapseElem);
    }
  }
}

initCollapses();
/* LISTEN FOR RELOAD AFTER AJAX CALL */
document.addEventListener('reloadCollapse', (e) => {
  initCollapses(e.detail.wrapper);
}, false);
